module.exports = __webpack_public_path__ + "static/menu-illupino-min2-675fd207e9f8c778d6be16069a5f0c86.jpg";